export const textStructurePool = [
    {
      passage: "Dogs are different from cats in several ways.",
      structure: "Compare/Contrast",
      distractors: ["Cause/Effect", "Chronological", "Problem/Solution"]
    },
    {
      passage: "The storm knocked out the power, so we used candles for light.",
      structure: "Cause/Effect",
      distractors: ["Compare/Contrast", "Chronological", "Description"]
    },
    {
      passage: "First, mix the batter. Next, pour it into the pan.",
      structure: "Chronological",
      distractors: ["Description", "Problem/Solution", "Compare/Contrast"]
    }
  ];
  